module.exports = __webpack_public_path__ + "img/svg/arrow-down.cb45eaaeadfa21046f110da6dc6f97f9.svg";